import * as React from "react";
import { TicketEvent } from "../../models/ticketEvent";
import { TicketTypeEntry } from "../ticketTypeEntry/ticketTypeEntry";
import { History } from "history";
import { bind } from "../../decorators/bind";
import { TicketType } from "../../models/ticketType";
import { BaseComponent } from "../baseComponent";
import { ReserveTicketModal } from "../reserveTicketModal/reserveTicketModal";
import { tracked } from "../../decorators/tracked";
import { Translate } from "../../services/translate";
import { lazyInject } from "../../services/container";

interface EventDetailsProps {
  event: TicketEvent;
  history: History;
  preselectedTicketTypeId: string | null;
}

export class EventDetails extends BaseComponent<EventDetailsProps> {
  @tracked
  private selectedTicketType: TicketType | null = null;

  @lazyInject(Translate)
  private translate: Translate;

  public render(): React.ReactNode {
    return (
      <div className="event-details">
        <div className="page-title">
          <div className="event-details-date">
            {this.props.event.eventDate.toFormat(
              this.translate.choose({
                en: "dd/LL cccc",
                hu: "LL.dd. cccc",
              })
            )}
          </div>
          <div className="event-details-name">{this.props.event.name}</div>
          <div className="event-details-location">
            {this.props.event.location} {this.props.event.eventDate.toFormat("HH:mm")}
          </div>
        </div>
        <div className="ticket-type-entries">
          {this.props.event.ticketTypes.map((ticketType) => (
            <TicketTypeEntry
              key={ticketType.id}
              ticketType={ticketType}
              history={this.props.history}
              onClick={() => this.onClick(ticketType)}
            />
          ))}
        </div>
        <div className="event-details-warning">{this.translate.translate("reservationWarning")}</div>
        <div className="event-details-text" dangerouslySetInnerHTML={{ __html: this.props.event.text }} />
        <ReserveTicketModal
          ticketType={this.selectedTicketType}
          history={this.props.history}
          onDismiss={this.onModalDismiss}
        />
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    const preselectedTicketTypeId = Number(this.props.preselectedTicketTypeId);
    console.log(this.props.preselectedTicketTypeId, preselectedTicketTypeId);

    if (preselectedTicketTypeId) {
      this.selectedTicketType = this.props.event.ticketTypes.find(ticketType => ticketType.id === preselectedTicketTypeId) || null;
    }
  }

  @bind
  private onClick(ticketType: TicketType): void {
    this.selectedTicketType = ticketType;
  }

  @bind
  private onModalDismiss() {
    this.selectedTicketType = null;
  }
}
